import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button, Container, Box, Typography, TextField } from "@mui/material";
import constants from "../utils/constants";
import { useLang } from "../context/LangContext";
import locales from "../locales.json";

const { BACKEND_URL } = constants;

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { lang } = useLang();
  const { reset_password_page } = locales;

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setError(reset_password_page.passwords_not_matching[lang]);
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${BACKEND_URL}/authentication/reset-password`, {
        token,
        newPassword,
      });

      setMessage(reset_password_page.success_message[lang]);
      setError(null);

      setTimeout(() => navigate("/signin"), 3000);
    } catch (err) {
      setError(reset_password_page.invalid_link[lang]);
      setMessage(null);
    }
    setLoading(false);
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: { xs: "100vh", md: "calc(100vh - 64px)" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: { xs: 1, sm: 2, md: 0 },
        boxSizing: "border-box",
        width: "100%",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          padding: { xs: "20px", sm: "32px" },
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          width: "100%",
          maxWidth: "400px",
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          align="center"
          sx={{ fontSize: { xs: "1.7rem", md: "2rem" } }}
        >
          {reset_password_page.title[lang]}
        </Typography>

        {message && (
          <Typography
            color="success.main"
            sx={{ marginTop: "8px", textAlign: "center" }}
          >
            {message}
          </Typography>
        )}
        {error && (
          <Typography
            color="error"
            sx={{ marginTop: "8px", textAlign: "center" }}
          >
            {error}
          </Typography>
        )}

        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <TextField
            fullWidth
            label={reset_password_page.new_password_label[lang]}
            name="newPassword"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            margin="normal"
            variant="outlined"
          />

          <TextField
            fullWidth
            label={reset_password_page.confirm_password_label[lang]}
            name="confirmPassword"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            margin="normal"
            variant="outlined"
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              marginTop: "24px",
              padding: { xs: "10px 0", md: "12px 0" },
              borderRadius: "24px",
              fontSize: { xs: "1rem", md: "1.1rem" },
            }}
            disabled={loading}
          >
            {loading
              ? reset_password_page.loading[lang]
              : reset_password_page.submit_button[lang]}
          </Button>
        </form>

        <Button
          variant="outlined"
          color="primary"
          fullWidth
          sx={{
            marginTop: "16px",
            padding: { xs: "10px 0", md: "12px 0" },
            borderRadius: "24px",
            fontSize: { xs: "1rem", md: "1.1rem" },
          }}
          onClick={() => navigate("/signin")}
        >
          {reset_password_page.back_to_signin[lang]}
        </Button>
      </Box>
    </Container>
  );
};

export default ResetPassword;
